import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const AssignTaskOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.22 4.54c-1.902 0-3.37 1.444-3.37 3.09v8.28c0 1.647 1.46 3.09 3.37 3.09H10a.8.8 0 0 1 0 1.6H8.22c-2.69 0-4.97-2.057-4.97-4.69V7.63c0-2.634 2.292-4.69 4.97-4.69h6.38c2.69 0 4.97 2.057 4.97 4.69v4.29a.8.8 0 0 1-1.6 0V7.63c0-1.647-1.46-3.09-3.37-3.09H8.22Zm-.59 3.33a.8.8 0 1 0 0 1.6H15a.8.8 0 0 0 0-1.6H7.63Zm0 3.5a.8.8 0 0 0 0 1.6h4.26a.8.8 0 0 0 0-1.6H7.63Zm13.056 3.525a.8.8 0 1 0-1.172-1.09l-4.813 5.179-1.554-1.678a.8.8 0 0 0-1.174 1.088l2.14 2.31a.8.8 0 0 0 1.173 0l5.4-5.81Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default AssignTaskOutlined
